import App from "./App.vue";
import { initRefresh } from "./utils/refresh";

initRefresh({ intervalMs: 5000 });

new Vue({
    render: h => h(App)
}).$mount("#app");
